export default __webpack_public_path__ + "static/media/priority.98e41a4d.png";